var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import React from "react";
import styled from "styled-components";
import { SizeEnum, TagColorEnum } from "../../enums";
var RevealTagSize = (_a = {},
    _a[SizeEnum.tiny] = {
        fontSize: 8,
    },
    _a[SizeEnum.small] = {
        fontSize: 10,
    },
    _a[SizeEnum.medium] = {
        fontSize: 12,
    },
    _a[SizeEnum.large] = {
        fontSize: 14,
    },
    _a[SizeEnum.giant] = {
        fontSize: 16,
    },
    _a);
var StyledRevealTag = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      background-color: ".concat(props.color, ";\n      border-radius: 50%;\n      font-size: 10px;\n      flex-shrink: 0;\n      height: ").concat(RevealTagSize[props.size].fontSize * 2, "px;\n      width: ").concat(RevealTagSize[props.size].fontSize * 2, "px;\n      cursor: pointer;\n  "); });
var RevealTag = function (_a) {
    var numHidden = _a.numHidden, _b = _a.size, size = _b === void 0 ? SizeEnum.medium : _b;
    return (React.createElement(StyledRevealTag, { color: TagColorEnum.grey, size: size, numHidden: numHidden, title: "View ".concat(numHidden, " more") },
        React.createElement("span", null,
            "+",
            numHidden)));
};
export default RevealTag;
var templateObject_1;
